import { FoComboCardMatchMarket, FoComboCardWithOdds } from '@staycool/sports-types/fo-combo-card';

export function getMarketIdsFromComboCardMatches(matches: FoComboCardWithOdds['matches']) {
    return matches.flatMap((match) => match.markets.map((market) => market.id));
}

export const checkIsCardMultiSport = (matches: FoComboCardWithOdds['matches']) => {
    const sportNameToCompareTo = matches[0].sport_name;
    return matches.some(({ sport_name }) => sport_name !== sportNameToCompareTo);
};

export const getRemainingBettingEndTime = (days: number, hours: number, minutes: number, seconds: number) => {
    if (days >= 1) {
        return `${days} day${days > 1 ? 's' : ''}`;
    } else {
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        return `${formattedHours}h ${formattedMinutes}m ${formattedSeconds}s`;
    }
};

export function getMarketsToDisplay(
    markets: FoComboCardMatchMarket[],
): Pick<FoComboCardMatchMarket, 'id' | 'outcome_name'>[] {
    const marketsToDisplay = markets.flatMap((market) => {
        const { id, view_type, name, outcome_name } = market;
        if (view_type !== 'bet_builder') {
            return [{ id, outcome_name }];
        }

        const outcomeNames = name.split(' And ');
        return outcomeNames.map((name, i) => ({ id: Number(`${id}${i}`), outcome_name: name }));
    });
    return marketsToDisplay;
}
